import { all } from "redux-saga/effects";
import {
  customFunctionValidateWatcher,
  customFunctionSaveWatcher,
  customFunctionListWatcher,
  customFunctionGetWatcher,
  customFunctionUpdateWatcher,
  customFunctionDeleteWatcher,
} from "../custom-function-saga";

export default function* customFunctionRootSaga() {
  yield all([
    customFunctionValidateWatcher(),
    customFunctionSaveWatcher(),
    customFunctionListWatcher(),
    customFunctionGetWatcher(),
    customFunctionUpdateWatcher(),
    customFunctionDeleteWatcher(),
  ]);
}
